<!-- Spacer -->
<div class="fuse-horizontal-navigation-item-wrapper" [ngClass]="item.classes?.wrapper"></div>
